const modulesFiles = require.context("./", true, /\.api\.js$/);
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const value = modulesFiles(modulePath);
  const moduleName = modulePath.substring(2).replace('.api.js','')
  //新增命名空间
  modules[moduleName] = {}
  for(let key of Object.keys(value)){
    modules[moduleName][key] = value[key]
  }
  return modules;
}, {});
export default modules